module.exports = __webpack_public_path__ + "static/media/truba_pr.e1dae469.png";